import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Shared section wrapper with optional centered eyebrow / title / subtitle header.
 */
function SectionContainer({ eyebrow, title, subtitle, id, children, sx, dense }) {
  const theme = useTheme();

  return (
    <Box
      component="section"
      id={id}
      sx={{
        py: dense ? { xs: 4, md: 6 } : { xs: 6, md: 10 },
        ...sx,
      }}
    >
      <Container maxWidth="lg">
        {(eyebrow || title || subtitle) && (
          <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
            {eyebrow && (
              <Typography
                variant="overline"
                sx={{
                  color: theme.palette.primary.main,
                  fontWeight: 700,
                  letterSpacing: '0.12em',
                  fontSize: '0.75rem',
                  display: 'block',
                  mb: 1,
                }}
              >
                {eyebrow}
              </Typography>
            )}
            {title && (
              <Typography
                variant="h3"
                component="h2"
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                  mb: subtitle ? 2 : 0,
                  fontSize: { xs: '1.75rem', md: '2.25rem' },
                }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  maxWidth: 600,
                  mx: 'auto',
                  lineHeight: 1.7,
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
        )}
        {children}
      </Container>
    </Box>
  );
}

SectionContainer.propTypes = {
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.object,
  dense: PropTypes.bool,
};

SectionContainer.defaultProps = {
  dense: false,
};

export default SectionContainer;
